import { useQuery } from '@tanstack/react-query';
import { fetchShipmentCategory } from '../../data-provider/select-options';
import type { GetShipmentCategoryRequestParams } from '../../data-provider/select-options/shipment-category/api';

export const useGetShipmentCategory = (params: GetShipmentCategoryRequestParams) => {
  return useQuery({
    queryKey: ['shipment-category-list', params.CustomerKey, params.CategoryId],
    queryFn: () => fetchShipmentCategory(params),
    enabled: !!(params.CustomerKey && params.CategoryId),
  });
};
